import type { ReactNode } from 'react'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'
import { cn } from '@/lib/utils'

/**
 * In-card empty state for analytics tabs (Paper "Filter with no results",
 * "No forms detected"): a 40px hairline icon well, a 14/500 title, a 13/20
 * muted line, then the actions. Smaller than the page-level `EmptyState`,
 * because it sits inside a card under a table header.
 */
export function AnalyticsEmpty({
  icon,
  title,
  description,
  children,
  className,
  descriptionClassName,
}: {
  icon: IconSvgElement
  title: ReactNode
  description?: ReactNode
  children?: ReactNode
  className?: string
  descriptionClassName?: string
}) {
  return (
    <div className={cn('flex flex-col items-center px-4 pt-12 pb-11 text-center', className)}>
      <div className="mb-4 flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted/60 ring-1 ring-border">
        <HugeiconsIcon icon={icon} size={18} className="text-muted-foreground" />
      </div>
      <p className="mb-1.5 text-sm font-medium leading-[18px] text-foreground">{title}</p>
      {description && (
        <p className={cn('max-w-[440px] text-[13px] leading-5 text-muted-foreground', descriptionClassName)}>{description}</p>
      )}
      {children}
    </div>
  )
}
